import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatDialogRef, MatDialog } from '@angular/material';
import { Title } from '@angular/platform-browser';
import { ClipBoardService } from 'src/app/services/clipboard.service';
import { ServerService } from 'src/app/services/server.service';
import { AddCallerIdModalComponent } from '../add-caller-id-modal/add-caller-id-modal.component';
import { CallerIdVerifyComponentComponent } from '../caller-id-verify-component/caller-id-verify-component.component';
import { RemoveCallerIdModalComponent } from '../remove-caller-id-modal/remove-caller-id-modal.component';
import { EditCallerIdModalComponent } from '../edit-caller-id-modal/edit-caller-id-modal.component';

@Component({
  selector: 'app-call-setting-dashboard',
  templateUrl: './call-setting-dashboard.component.html',
  styleUrls: ['./call-setting-dashboard.component.scss']
})
export class CallSettingDashboardComponent implements OnInit {

  showComponentLoader: boolean = false
  authToken: any = localStorage.getItem("token")
  userInfo: any = JSON.parse(localStorage.getItem("userInfo"))
  elasticSearch: any = ""

  user: any = {
    users: [],
    pagination: {}
  }

  callerIDList:any;

  showChartStats: boolean = false

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  pageIndex: number = 0;
  pageSize: number = 50;

  AddCallerIdModalComponent: MatDialogRef<AddCallerIdModalComponent>
  CallerIdVerifyComponentComponent: MatDialogRef<CallerIdVerifyComponentComponent>
  RemoveCallerIdModalComponent: MatDialogRef<RemoveCallerIdModalComponent>
  EditCallerIdModalComponent: MatDialogRef<EditCallerIdModalComponent>

  constructor(
    private dialog: MatDialog,
    private serverService: ServerService,
    private titleService: Title,
    private clipBoardService: ClipBoardService
  ) {
    this.showComponentLoader = true
    this.titleService.setTitle('AutomateLeads - Users');
    if (this.clipBoardService.userName != "") {
      this.elasticSearch = this.clipBoardService.userName
    }
  }


  ngOnInit() {
    this.getAllCallerIds()
    //this.verifyCallerId()
  }

  getAllCallerIds() {

    this.pageIndex = 0;
    this.pageSize = 50;

    this.showComponentLoader = true

    //let url = "caller_numbers/?per_page=" + this.pageSize + "&page=" + this.pageIndex;
    let url = "caller_numbers";

    this.serverService.getCallerId(url, this.authToken).subscribe(data => {
        this.callerIDList = data
        this.showComponentLoader = false
      },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )
  }

  getNext(event) {
    this.showComponentLoader = true
    let body1 = {
      "per_page": event.pageSize,
      "page": event.pageIndex
    };
    let body = {}
    this.pageSize = body1.per_page;
    this.pageIndex = body1.page
    let indexPage = this.pageIndex + 1


    // console.log(body)
    let url = "all_users_search_n_filter?per_page=" + this.pageSize + "&page=" + indexPage;
    this.serverService.getUsersByFilter(url, body, this.authToken).subscribe(
      data => {
        this.user = data
        this.showComponentLoader = false
      },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )
  }


  create() {
    this.AddCallerIdModalComponent = this.dialog.open(AddCallerIdModalComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '500px',
      panelClass: 'cdk-overlay-panel-right-side'
    });
    this.AddCallerIdModalComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        if (result.status == 200) {
          this.verifyCallerId(result)
        } else if (result.status == 400) {
          this.clipBoardService.showMessgeInText("Phone number is already verified", "error-snackbar");
          this.getAllCallerIds()
        }
      }
    })
  }

  update(element) {
    this.EditCallerIdModalComponent = this.dialog.open(EditCallerIdModalComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      data: element,
      width: '500px',
      panelClass: 'cdk-overlay-panel-right-side'
    });
    this.EditCallerIdModalComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        this.getAllCallerIds()
      }
    })
  }

  makedefault(event:any, element:any) {

    if(!element.id){
      return false
    }

    let body = {
      "id": element.id,
    }

    this.serverService.makeDefaultCallerId(body, this.authToken).subscribe(data => {
      this.clipBoardService.showMessgeInText("Default Set Succesfully", "success-snackbar");
      this.getAllCallerIds()
      },
      err => {
        let message = JSON.parse(err._body);
        if (err.status == 422) {
          this.clipBoardService.showMessgeInText(JSON.stringify(message.errors), "error-snackbar");
        } else {
          this.clipBoardService.checkServerError(err, this.authToken)
        }
      }
    )
  }

  verifyCallerId(otp: any) {
    this.CallerIdVerifyComponentComponent = this.dialog.open(CallerIdVerifyComponentComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '500px',
      data: otp
    });
    this.CallerIdVerifyComponentComponent.afterClosed().subscribe(result => {
      this.getAllCallerIds()
    });
  }

  removeCallerId(element) {
    this.RemoveCallerIdModalComponent = this.dialog.open(RemoveCallerIdModalComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '500px',
      data: element
    });
    this.RemoveCallerIdModalComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        //return element = result
        this.getAllCallerIds()
      }
    });
  }


  removeSearch() {
    this.elasticSearch = ""
    this.clipBoardService.userName = ""
    this.getAllCallerIds()
  }

}
